module.exports = __webpack_public_path__ + "img/philippe_jaroussky.ad531a24.jpg";